(() => {
  const script = document.querySelector('script[data-la1970-dealer-display]');
  if (!script || window.__la1970B2BPrices) return;
  window.__la1970B2BPrices = true;
  const locale = document.documentElement.lang || 'de';
  const money = new Intl.NumberFormat(locale, {style:'currency',currency:'EUR'});
  const percent = new Intl.NumberFormat(locale,{maximumFractionDigits:2});
  const root = script.dataset.root || '';
  const labels = {list:script.dataset.labelList,price:script.dataset.labelPrice,save:script.dataset.labelSave};
  const cardVariants = new Map();
  let generation = 0, timer;
    function accountButton() {
    const account = document.querySelector(".header__icons .header__icon--account");
    if (!account || account.querySelector(".la1970-account-cta__label")) return;
    const targetUrl = script.dataset.customerAuthenticated === "true" ? script.dataset.accountUrl : script.dataset.accessUrl;
    if (targetUrl) account.href = targetUrl;
    account.classList.add("la1970-account-cta");
    account.setAttribute("aria-label", script.dataset.labelAccount || script.dataset.labelAccountShort || "Account");
    const full = document.createElement("span");
    full.className = "la1970-account-cta__label";
    full.textContent = script.dataset.labelAccount || "Account";
    const short = document.createElement("span");
    short.className = "la1970-account-cta__short";
    short.textContent = script.dataset.labelAccountShort || "Account";
    account.append(full, short);
    const drawerAccount = document.querySelector(".menu-drawer__account");
    if (drawerAccount) {
      drawerAccount.classList.add("la1970-account-cta--drawer");
      if (targetUrl) drawerAccount.href = targetUrl;
    }
  }


  accountButton();
  if (script.dataset.customerAuthenticated !== 'true') return;
  if (window.Shopify?.currency?.active && window.Shopify.currency.active !== 'EUR') return;
  function clear() {
    document.querySelectorAll('[data-la1970-dealer-result]').forEach(e=>e.remove());
  }
  function valid(row) {
    return row && row.currency==='EUR' && Number.isFinite(row.regular) && row.regular>0 && Number.isFinite(row.discounted) && row.discounted>=0 && row.discounted<=row.regular && Number.isFinite(row.discountPercent) && row.discountPercent>0 && row.discountPercent<=60 && Math.abs(Math.round(row.regular*(1-row.discountPercent/100)*100)/100-row.discounted)<0.011;
  }
  function text(tag,value,className) {
    const node=document.createElement(tag);node.textContent=value;if(className)node.className=className;return node;
  }
  function render(target,row,card) {
    if(!target||!valid(row))return;
    const box=document.createElement('div');box.dataset.la1970DealerResult='price';box.className='la1970-dealer-price';
    box.append(text('span',`${labels.list}: ${money.format(row.regular)}`,'la1970-dealer-list'),text('strong',`${labels.price}: ${money.format(row.discounted)}`),text('span',`${labels.save}: ${percent.format(row.discountPercent)} %`));
    const link=text('a',script.dataset.labelOverview);link.href=script.dataset.profileUrl;link.className='la1970-dealer-overview';box.append(link);
    const note=text('small',script.dataset.labelNote);box.append(note);target.append(box);
    if(card){
      const holder=card.querySelector('.card__inner');
      if(holder){const badge=text('a',`−${percent.format(row.discountPercent)} %`,'la1970-dealer-badge');badge.href=script.dataset.profileUrl;badge.dataset.la1970DealerResult='badge';badge.setAttribute('aria-label',`${labels.save}: ${percent.format(row.discountPercent)} %. ${script.dataset.labelOverview}`);holder.append(badge);}
    }
  }
  async function prices(ids) {
    const merged={};let eligible=false;
    for(let i=0;i<ids.length;i+=50){
      const url=new URL(script.dataset.proxy,location.origin);url.searchParams.set('variants',ids.slice(i,i+50).join(','));
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('unavailable');
      const data=await response.json();if(data.eligible!==true)return {eligible:false,prices:{}};
      eligible=true;Object.assign(merged,data.prices||{});
    }
    return {eligible,prices:merged};
  }
  function selectedVariant(){
    const data=document.querySelector('[data-la1970-dealer-product]');if(!data)return null;
    let variants;try{variants=JSON.parse(data.textContent);}catch{return null;}
    const form=document.querySelector('.product__info-container form[action*="/cart/add"],product-info form[action*="/cart/add"]');
    const id=form?.querySelector('[name="id"]')?.value||new URL(location.href).searchParams.get('variant')||variants.find(v=>v.available)?.id||variants[0]?.id;
    return variants.some(v=>String(v.id)===String(id))?`gid://shopify/ProductVariant/${id}`:null;
  }
  async function update(){
    const run=++generation;clear();
    const current=selectedVariant();const cards=new Map();
    for(const link of document.querySelectorAll('a[href*="/products/"]')){
      const handle=link.pathname.match(/\/products\/([^/?#]+)/)?.[1];const card=link.closest('.card-wrapper,.product-card-wrapper,[data-product-card]');
      if(handle&&card){if(!cards.has(handle))cards.set(handle,[]);if(!cards.get(handle).includes(card))cards.get(handle).push(card);}
    }
    try{
      await Promise.all([...cards.keys()].map(async handle=>{
        if(cardVariants.has(handle))return;
        const response=await fetch(`${root}/products/${handle}.js`,{credentials:'same-origin',headers:{Accept:'application/json'}});if(!response.ok)return;
        const product=await response.json();const v=product.variants?.find(x=>x.available)||product.variants?.[0];if(v)cardVariants.set(handle,`gid://shopify/ProductVariant/${v.id}`);
      }));
      const ids=[...new Set([current,...[...cards.keys()].map(h=>cardVariants.get(h))].filter(Boolean))];
      if(!ids.length)return;const data=await prices(ids);if(run!==generation||!data.eligible)return;
      if(current&&selectedVariant()===current){const target=document.querySelector('.product__info-container .price,product-info .price')?.parentElement;render(target,data.prices[current]);}
      for(const [handle,list]of cards)for(const card of list){const target=card.querySelector('.card-information,.price')?.parentElement;render(target,data.prices[cardVariants.get(handle)],card);}
    }catch{if(run===generation)clear();}
  }
  function schedule(){++generation;clearTimeout(timer);clear();timer=setTimeout(update,250);}
  document.addEventListener('change',e=>{if(e.target.closest('product-info,.product__info-container,variant-selects'))schedule();});
  document.addEventListener('shopify:section:load',schedule);
  const observer=new MutationObserver(records=>{if(records.some(r=>r.type==='childList'&&[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1&&!n.matches('[data-la1970-dealer-result]')&&(n.matches('product-info,.product__info-container,.card-wrapper,[name="id"]')||n.querySelector('product-info,.product__info-container,.card-wrapper,[name="id"]')))))schedule();});
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){++generation;clear();}else schedule();});
  setInterval(()=>{if(!document.hidden)schedule();},60000);
  update();
})();
